import React from "react"
import { Rating } from ".."
import moment from "moment"
import "moment/locale/uz"

export default ({ data }) => {
  return (
    <section className="flex flex-col items-start justify-center w-full">
      {data?.comments?.map(
        (feedback, indx) =>
          feedback?.comment.trim() && (
            <div
              className="flex flex-col items-start justify-center w-full py-4"
              key={`${indx + 1}`}
            >
              <div className="flex flex-col items-start justify-start gap-5">
                <div className="flex items-center justify-start">
                  <div className="relative w-14 h-14">
                    {feedback?.photo !== null ? (
                      <img
                        className="rounded-full"
                        src={feedback?.photo}
                        alt={feedback?.photo}
                      />
                    ) : (
                      <div className="flex items-center justify-center p-1 border rounded-full w-14 h-14">
                        <svg
                          className="text-gray-400 "
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </div>
                    )}
                  </div>
                  <div>
                    <p className="mt-2 font-medium sm:ml-4 sm:mt-0">
                      {feedback?.fullName}
                    </p>
                  </div>
                </div>

                <header className="sm:flex sm:items-center">
                  <div className="flex items-center justify-start gap-2">
                    <Rating commonRate={feedback?.rate} smaller />
                    <div className="flex items-center justify-start gap-2 ">
                      <p className="text-xs text-gray-500">
                        {moment(feedback?.rateDate)
                          .locale("uz")
                          .format("MMMM Do, YYYY")}
                      </p>
                    </div>
                  </div>
                </header>

                <p className="mt-2 text-gray-700">{feedback?.comment}</p>
              </div>
            </div>
          )
      )}
    </section>
  )
}
